import { put, call, select, take, takeEvery, takeLatest, fork } from 'redux-saga/effects'

import * as map from '../map'
import * as sfproxy from '../sfproxy'
import { getParkingEvents } from 'grs/api'
import { apiLanguageCodeSelector } from 'i18n/selectors'
import { indicateProgress } from 'api'

import * as constants from './constants'
import * as actions from './actions'
import * as api from './api'

import { selectedLocationTitleSelector } from './selectors'

export function* eventsSearchSaga() {
    yield takeLatest(constants.SEARCH_REQUEST_EVENTS, function* ({ eventName, locationId, startDate, endDate }) {
        if (!eventName && !locationId) return

        yield put(actions.clearSearchEvents())
        const apiLanguageCode = yield select(apiLanguageCodeSelector)

        const events = yield call(
            indicateProgress,
            ['getParkingAllEvents'],
            getParkingEvents,
            locationId,
            startDate,
            endDate,
            eventName,
            apiLanguageCode
        )

        yield put(actions.eventsReceived(events))
    })
}

export function* locationSearchSaga() {
    yield takeLatest(constants.SEARCH_REQUEST_LOCATIONS_BY_NAME, function* (action) {
        const { name } = action

        if (!name) return

        yield put(
            sfproxy.actions.fetchLocations(
                {
                    location: {
                        normalizedName: name,
                    },
                },
                0
            )
        )

        yield fork(function* () {
            const {
                result: { content, totalElements },
            } = yield take(sfproxy.constants.RECEIVED_LOCATIONS)
            yield put(actions.locationsReceived(content, totalElements))
        })

        yield fork(function* () {
            try {
                const results = yield call(api.fetchGooglePlaces, name)
                yield put(actions.googleLocationsReceived(results))
            } catch (exception) {}
        })
    })
}

export function* selectLocationSaga() {
    yield takeLatest(constants.SELECT_SEARCH_LOCATION, function* ({ location: { value: id, type } }) {
        switch (type) {
            case constants.SUGGESTION_TYPE_PARKING_LOT:
                yield call(function* () {
                    const {
                        geoLocation: { x: lat, y: lng },
                    } = yield select(sfproxy.selectors.createLocationByIdSelector(id))
                    yield put(map.actions.setLocation({ lat, lng }))
                    yield put(map.actions.setActiveLocation(id, false, { lat, lng }))
                    yield put(map.actions.setZoom(17))
                })
                break

            case constants.SUGGESTION_TYPE_GOOGLE_LOCATION:
                yield call(function* () {
                    const { x: lat, y: lng } = yield call(api.getGoogleLocationGeocodeById, id)
                    const title = yield select(selectedLocationTitleSelector)
                    yield put(map.actions.setLocation({ lat, lng }))
                    yield put(map.actions.setActiveSearchLocation({ lat, lng, title }))
                    yield put(map.actions.setZoom(17))
                })
                break
        }
    })
}

export function* rootSaga() {
    yield fork(locationSearchSaga)
    yield fork(eventsSearchSaga)
    yield fork(selectLocationSaga)
}
